import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomerSiteService from "../../Controller/CustomerSiteController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateCustomerSite from './CreateCustomerSite';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function CustomersitePage({ ClientCompanyID }) {
    const navigate = useNavigate();
    ClientCompanyID = localStorage.getItem('ClientCompanyID');
    const tableRef = useRef();
    const [CustomerSiteList, setCustomerSites] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentCustomerSite, setCurrentCustomerSite] = useState(null);
    const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (CustomerSiteList.length > 0) {
            initDataTable();
        }
    }, [CustomerSiteList]);
    const fetchCustomerSites = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await CustomerSiteService.GetAllCustomersSites(redirectCallback, ClientCompanyID);
            setCustomerSites(data);
        } catch (error) {
            console.error('Error fetching Sites:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    useEffect(() => {
        if (ClientCompanyID > 0) {
            fetchCustomerSites();
        }
    }, [ClientCompanyID]);

    const handleCreateCustomerSiteClick = () => {
        if (localStorage.getItem('CustomerSiteContact') === null) {
            localStorage.setItem('CustomerSiteContact', "0");
        }
        setCurrentCustomerSite(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (site) => {
        setCurrentCustomerSite(site);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await CustomerSiteService.DeleteCustomerSite(ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchCustomerSites(); //
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };

    const handleSuccess = () => {

        fetchCustomerSites(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const truncateText = (text, maxLength = 25) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateCustomerSiteClick}>

                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div>
                        <table className="table m-0 table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th className="no-wrap">Site Name</th>
                                    <th className="no-wrap">Address</th>
                                    <th className="no-wrap">Phone</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {CustomerSiteList.map((site) => (
                                    <tr key={site.ClientBranchID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(site) : undefined} style={{ cursor: 'pointer' }}
                                        className={site.HeadOffice === 1 ? 'boldRow' : ''}>


                                        <td className="no-wrap">{truncateText(site.BranchName)}</td>
                                        <td className="no-wrap">{truncateText(site.Address1)}</td>
                                        <td className="no-wrap">

                                            <a href={`tel:${site.Phone1}`} onClick={(e) => e.stopPropagation()}>
                                                {truncateText(site.Phone1)}
                                            </a>
                                        </td>
                                        <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, site.ClientBranchID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateCustomerSite
                    site={currentCustomerSite}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    CustomerID={ClientCompanyID}
                />
            )}
        </div>
    );
}

export default CustomersitePage;
